module.exports = __webpack_public_path__ + "static/lions-8553c9fdd702adfa31d40fd7cc421365.png";